import React, { useState, useEffect } from 'react';
import { ClipLoader } from 'react-spinners';
import headerIcon from '../images/republicHeader.png';
import republicDayIcon from '../images/republicDayIcon.png';
import { useNavigate } from 'react-router-dom';
import * as APIHelper from '../Helper/apiFetch';
import { BsShareFill } from "react-icons/bs";
import sats from '../images/sats.png';
import timer from '../images/timer2.png';
import CongLottie from '../lottie/conglottie.json';
import wowLottie from '../lottie/wowlottie.json';
import Marquee from "react-fast-marquee";
import FAQ from '../components/FAQ';
import TermsAndCondition from "../components/TermsAndCondition";
import { Link } from 'react-router-dom';
import * as nativeEvents from '../Helper/native';
const initiaData = require('../components/urlEncodeTest.json');

const CLAIMED_REWARDS_MAP = {
    NOT_PLAYED: 0,
    WON_REWARD: 1,
    NO_REWARD: 2
}

const REWARD_TYPE = {
    /* SATS: 0,
    PERCENTAGE: 1,
    CARDDISCOUNT: 2,
    CARDLOAD:3,
    TXN: 4 */

    SATS: 0,
    CARDLOAD: 1,
    CARDPURCHASE: 2,
    CARDUPGRADE: 3,
    TXN: 4,
    PERCENTAGE: 5,
    CARDDISCOUNT: 6,
    CARDACTIVATE: 7
}
const LandingScreen = () => {
    const targetDate = new Date('2025-01-31T23:59:59');
    const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());
    const [showTimer, setShowTimer] = useState(false);
    const [alreadyClimed, setAlreadyClimed] = useState(initiaData?.streak.alreadyClimedReward);
    const [rewardType, setRewardType] = useState(-1)
    const [bgcolor, setbgcolor] = useState("");
    const [climed, setClimed] = useState(CLAIMED_REWARDS_MAP.NOT_PLAYED);
    const [loading, setLoading] = useState(false);
    const [enableQuiz, setEnableQuiz] = useState(false);
    const [rewardedOn, setRewardedOn] = useState();
    const [rewardTimeLeft, setRewardTimLeft] = useState();
    const [status, setStatus] = useState("order_campaign_reward_created")

    const quizSteak = initiaData?.streak.quizDetails;
    const navigate = useNavigate();
    useEffect(() => {
        // Update remaining time every second
        const timer = setInterval(() => {
            const updatedRemainingTime = calculateRemainingTime();
            setRemainingTime(updatedRemainingTime);

            if (updatedRemainingTime.days <= 2 && !showTimer) {
                setShowTimer(true);
            }

        }, 1000);
        const fetchDailyQuiz = async () => {
            setLoading(true);

            try {
                APIHelper.quizInfo().then(resp => {
                    if (!resp.error) {
                        setEnableQuiz(true);
                        setLoading(false);
                        // setRewardedOn(resp?.rewards?.createdOn)
                        setRewardedOn(resp?.rewards?.createdOn)
                        setStatus(resp?.txnStatus)
                        setClimed(climed => {
                            if (resp.rewards !== undefined) {
                                setRewardType(x => {
                                    switch (resp.rewards.type) {
                                        case "sats":
                                            return REWARD_TYPE.SATS
                                        case "card-percentage":
                                            return REWARD_TYPE.PERCENTAGE
                                        case "card-discount":
                                            return REWARD_TYPE.CARDDISCOUNT
                                        case "card_load":
                                            return REWARD_TYPE.CARDLOAD
                                        case "txn":
                                            return REWARD_TYPE.TXN
                                        case "card_purchase":
                                            return REWARD_TYPE.CARDPURCHASE
                                        case "card_upgrade":
                                            return REWARD_TYPE.CARDUPGRADE
                                        case "card_activate":
                                            return REWARD_TYPE.CARDACTIVATE
                                        default:
                                            return -1
                                    }
                                })
                                climed = resp.rewards.value === 0 ? CLAIMED_REWARDS_MAP.NO_REWARD : CLAIMED_REWARDS_MAP.WON_REWARD
                                setAlreadyClimed(aClimed => {
                                    aClimed.quizClimedReward.sats = resp?.rewards?.code ? resp?.rewards?.code : resp?.rewards?.value;
                                    return aClimed;
                                })
                            }
                            return climed;
                        });
                    } else {
                        navigate('/error');
                    }
                })
            } catch (error) {
                console.error("Error fetching match data: ", error);
            }
        };
        fetchDailyQuiz();
        // Clear the interval when the component unmounts
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
    }, [climed])

    useEffect(() => {
        setbgcolor(quizSteak?.bgColor)
    }, [quizSteak])
    useEffect(() => {
        // Call the function once initially
        calculateExpireTimings(rewardedOn, setRewardTimLeft);

        // Set up an interval to update the time every second
        const interval = setInterval(() => {
            calculateExpireTimings(rewardedOn, setRewardTimLeft);
        }, 1000);

        // Clear the interval when the component unmounts
        return () => clearInterval(interval);
    }, [rewardedOn]);
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: CongLottie,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const defaultLottie = {
        loop: true,
        autoplay: true,
        animationData: wowLottie,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    function calculateRemainingTime() {
        const now = new Date();
        const difference = targetDate - now;
        // Check if the target time has already passed
        if (difference < 0) {
            return 0;
        }
        // Convert the difference to hours, minutes, and seconds
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return { hours, minutes, seconds, days };
    }
    function calculateExpireTimings(rewardedOn) {
        const now = new Date();
        const rewardedDate = new Date(rewardedOn); // Ensure rewardedOn is a valid Date object
        const nextTwoHours = new Date(rewardedDate.getTime() + 2 * 60 * 60 * 1000); // Add 2 hours to rewardedOn
        const difference = nextTwoHours - now; // Calculate the time difference between now and nextTwoHours

        // Check if the target time (rewardedOn + 2 hours) has already passed
        if (difference <= 0) {
            return 0;
        }

        // Convert the difference to days, hours, minutes, and seconds
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        // return { hours, minutes, seconds, days };
        setRewardTimLeft({ hours, minutes, seconds, days })
    }

    const shareWithFriends = () => {
        // APIHelper.postAnalytics("share_from_home");
        nativeEvents.shareWithFriends(initiaData.floatingShareMsg.msg);
    }
    /* const shimerLoader = () => {
        return (
            <div className="republic-shimmer-effect">
            </div>
        )
    } */
    const shimerLoader = () => {
        return (
            <div className='republic-shimmer-effect'>
                <ClipLoader
                    size={60}
                    color={'#000000'}
                    aria-label="Loading Spinner"
                />
            </div>
        )
    }
    const getRewardMessage = () => {
        switch (rewardType) {
            case REWARD_TYPE.SATS:
                return (
                    <div className='winSats-Title'>
                        <span dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.climedTitle.replace('$', alreadyClimed.quizClimedReward.sats) }} />
                    </div>
                )
            case REWARD_TYPE.PERCENTAGE:
                return (
                    <div className='winSats-Title'
                        dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.climePerReward.replace('$', alreadyClimed.quizClimedReward.sats) }}
                    />
                )
            case REWARD_TYPE.CARDDISCOUNT:
                return (
                    <div className='winSats-Title'
                        dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.cardDiscount.replace('$', alreadyClimed.quizClimedReward.sats) }} />
                )
            case REWARD_TYPE.TXN:
                return (
                    <div className='winSats-Title'
                        dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.cardAndVoucherTxn.replace('$', alreadyClimed.quizClimedReward.sats) }} />
                )
            case REWARD_TYPE.CARDLOAD:
                return (
                    <div className='winSats-Title'
                        dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.cardLoad.replace('$', alreadyClimed.quizClimedReward.sats) }} />
                )
            case REWARD_TYPE.CARDUPGRADE:
                return (
                    <div className='winSats-Title'
                        dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.cardUpgrade }} />
                )
            case REWARD_TYPE.CARDACTIVATE:
                return (
                    <div className='winSats-Title'
                        dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.cardActivate }} />
                )
            case REWARD_TYPE.CARDPURCHASE:
                return (
                    <div className='winSats-Title'
                        dangerouslySetInnerHTML={{ __html: alreadyClimed.quizClimedReward.cardUpgrade }} />
                )
            default:
                return (
                    <div className='winSats-Title'>
                    </div>
                )
        }
    }
    const contentDisplay = () => {
        return (
            <>
                <div className='headder'>
                    <div className='headderMarquee'>
                        <div className='rightLayout'>
                        </div>
                        <div className='leftLayout'>
                        </div>
                        <Marquee speed={30} gradientColor='none' direction='left'>
                            <div className='wazirxHeadderTimerTitle'>
                                Get a chance to win exciting rewards by participating in the quiz everyday.
                            </div>
                        </Marquee>
                        <div className='campTimerContainer' style={{ width: "120px", marginLeft: '0px' }}>
                            <img alt=' ' className='timerIcon' src={'https://assets.gosats.io/notification/2024/12/1734692217708'} />
                            <div className='timeCounter'>
                                {remainingTime === 0 ? (
                                    '00:00:00'
                                ) : (
                                    <div style={{ display: 'flex', gap: '2px', marginBottom: '2px' }}>
                                        {remainingTime.hours != 24
                                            ? `${remainingTime.days} days left`
                                            : `${String(remainingTime.days * 24 + remainingTime.hours).padStart(2, '0')}:${String(remainingTime.minutes).padStart(2, '0')}:${String(remainingTime.seconds).padStart(2, '0')}`}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* <div className='headderDiv'></div> */}
                    <div className='landingShareIconContainer'>
                        <button className="landingShareIcon" onClick={() => shareWithFriends()}>
                            <BsShareFill size={32} />
                        </button>
                    </div>
                    <img className='headderIcon' src={headerIcon} alt="Republic Day Icon" />
                    <div className='head-title'>Get a chance to unlock bonus Sats, cashback, and exclusive rewards. Play now and make this Republic Day rewarding!</div>
                    <div className='republicIconContainer'>
                        <img src={republicDayIcon} className='republicIcon' alt='Icon' />
                    </div>
                    {
                        rewardType != -1 ?
                            <div className='republicRewardDisplay'>
                                {
                                    rewardType != 0 && status === "order_campaign_reward_created" ?
                                        <div className='quizTimerContainer'>
                                            <div className='quizTimer' style={{ marginTop: '-45px' }}>
                                                <img src={timer} className='timer-Icon' alt=' ' />
                                                :
                                                <div className='quizTimerBg' style={{ color: '#000000' }}>
                                                    {/* {`${String(rewardTimeLeft.hours).padStart(2, '0')}:${String(rewardTimeLeft.minutes).padStart(2, '0')}:${String(rewardTimeLeft.seconds).padStart(2, '0')}`} */}
                                                    {rewardTimeLeft.hours === 0 && rewardTimeLeft.minutes === 0 && rewardTimeLeft.seconds === 0
                                                        ? "00:00:00"
                                                        : `${String(rewardTimeLeft.hours).padStart(2, '0')}:${String(rewardTimeLeft.minutes).padStart(2, '0')}:${String(rewardTimeLeft.seconds).padStart(2, '0')}`}
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                                {/* alreadyClimed.quizClimedReward.climedTitle */}
                                {
                                    status === "order_campaign_reward_expired" ? (
                                        <div className="winSats-Title">
                                            {alreadyClimed.quizClimedReward.expired}
                                        </div>
                                    ) : status === "order_campaign_reward_created" ? (
                                        getRewardMessage()
                                    ) : status === "order_completed" ?
                                        <div className="winSats-Title">
                                            {alreadyClimed.quizClimedReward.climedTitle}
                                        </div>
                                        :
                                        (
                                            <div className="winSats-Title">
                                                {alreadyClimed.quizClimedReward.pending}
                                            </div>
                                        )
                                }
                                {
                                    rewardType === 1 && status != "order_completed" ?
                                        <div style={{ marginTop: '20px' }}>
                                            <button className='republicCampQuizCta' style={{ opacity: status === "order_campaign_reward_expired" ? 0.4 : 1 }}
                                                disabled={status === "order_campaign_reward_expired"}
                                                onClick={() => {
                                                    nativeEvents.loadCard();
                                                }}>
                                                CLAIM THE REWARD
                                            </button>
                                        </div>
                                        :
                                        null
                                }
                                {
                                    rewardType === 2 && status != "order_completed" ?
                                        <div style={{ marginTop: '20px' }}>
                                            <button className='republicCampQuizCta' style={{ opacity: status === "order_campaign_reward_expired" ? 0.4 : 1 }}
                                                disabled={status === "order_campaign_reward_expired"}
                                                onClick={() => {
                                                    nativeEvents.purchaseCard();
                                                }}>
                                                UPGRADE THE CARD
                                            </button>
                                        </div>
                                        :
                                        null
                                }
                                {
                                    rewardType === 3 && status != "order_completed" ?
                                        <div style={{ marginTop: '20px' }}>
                                            <button className='republicCampQuizCta' style={{ opacity: status === "order_campaign_reward_expired" ? 0.4 : 1 }}
                                                disabled={status === "order_campaign_reward_expired"}
                                                onClick={() => {
                                                    nativeEvents.upgradeCard();
                                                }}>
                                                UPGRADE THE CARD
                                            </button>
                                        </div>
                                        :
                                        null
                                }
                                {
                                    rewardType === 4 && status != "order_completed" ?
                                        <div style={{ marginTop: '20px' }}>
                                            <button className='republicCampQuizCta' style={{ opacity: status === "order_campaign_reward_expired" ? 0.4 : 1 }}
                                                disabled={status === "order_campaign_reward_expired"}
                                                onClick={() => {
                                                    nativeEvents.goBack();
                                                }}>
                                                CLAIM THE REWARD
                                            </button>
                                        </div>
                                        :
                                        null
                                }
                                {
                                    rewardType === 7 && status != "order_completed" ?
                                        <div style={{ marginTop: '20px' }}>
                                            <button className='republicCampQuizCta' style={{ opacity: status === "order_campaign_reward_expired" ? 0.4 : 1 }}
                                                disabled={status === "order_campaign_reward_expired"}
                                                onClick={() => {
                                                    nativeEvents.activateCard();
                                                }}>
                                                ACTIVATE CARD
                                            </button>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            : null
                    }
                    <div style={{ marginBottom: '30px', marginTop: '40px' }}>
                        <FAQ />
                    </div>
                    <TermsAndCondition />
                </div>
                <div className='republicCampQuizCtaContainer'>
                    <div>
                        {
                            climed === 0 ?
                                <div>
                                    <div className='footerTitle'>
                                        Participate now to win big!
                                    </div>
                                    <Link to='/quiz' className='republicCampQuizCta' >
                                        ENTER QUIZ
                                    </Link>
                                </div>
                                :
                                <div>
                                    <div className='footerTitle'>
                                        You've participated in the quiz <br />
                                        Come back tomorrow to win exciting rewards.
                                    </div>
                                    <button disabled={true} className='republicCampQuizCta' style={{ opacity: 0.4 }}>
                                        ENTER QUIZ
                                    </button>
                                </div>
                        }
                    </div>
                </div>
            </>
        )
    }
    return (
        <div>
            {loading ? shimerLoader() : contentDisplay()}
        </div>
    )
}

export default LandingScreen
